import React, {useState, useCallback, useEffect} from 'react';
import {connect} from 'react-redux';
import {View, Text, StyleSheet} from 'react-native';
import CustomButton from '../../../commonComponents/CustomButton';
import {globalFontStyle} from '../../../assets';
import {globalImport} from '../../../common/globalImports';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {globalConfigurableData} from '../../../utils/globalConstant';
import Gradient from '../../../commonComponents/Gradient';

const PreviousEarnings = ({onLearnMore, earningsDetail = []}) => {
  //const [earningsDetail, setEarningdetail] = useState([]);

  // const getEarnings = async () => {
  //   const res = await Network.getRewardHistory();
  //   if (res?.data) {
  //     setEarningdetail(res?.data);
  //   }
  // };

  // useEffect(() => {
  //   getEarnings();
  // }, []);

  return (
    <View style={{paddingTop: 15, paddingBottom: 20, paddingHorizontal: 16}}>
      <FormTextLabel
        labelStyles={[
          {
            ...globalFontStyle.appFontTitle,
            color: globalConfigurableData.primaryTextColor1,
          },
        ]}
        label={'Previous Earnings'}
      />
      <Gradient
        colors={['#CA2C92', '#5037BF']}
        // locations={[0.017, 0.65]}
        end={{x: 0.1, y: 0.4}}
        style={{
          borderRadius: 8,
          backgroundColor: '#F9F9F9',
          borderColor: '#CFCFCF',
          borderWidth: 0.75,
          marginVertical: 20,
        }}>
        <View
          style={[
            {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingHorizontal: 20,
              paddingVertical: 10,
            },
          ]}>
          <Text
            style={{
              ...globalFontStyle.appFontBody,
              color: globalConfigurableData.globalThemeColor,
            }}>
            Month
          </Text>
          <Text
            style={{
              ...globalFontStyle.appFontSubHeading,
              color: globalConfigurableData.globalThemeColor,
            }}>
            Earnings (in TradeX Credits)
          </Text>
        </View>
        <View
          style={{
            margin: 1,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            backgroundColor: globalConfigurableData.globalThemeColor,
          }}>
          {earningsDetail?.map((item, index) => {
            return (
              <View key={index} style={styles.listItemsStyle}>
                <Text
                  style={{
                    ...globalFontStyle.appFontBody,
                    color: globalConfigurableData.primaryTextColor1,
                  }}>
                  {item.month}
                </Text>
                <Text
                  style={{
                    ...globalFontStyle.appFontSubHeading,
                    color: globalConfigurableData.profitColor,
                  }}>
                  +{item.amount}
                </Text>
              </View>
            );
          })}
        </View>
      </Gradient>
      <CustomButton
        btnText={'Keep Earning!'}
        btnType={'btnBlack'}
        onBtnClick={onLearnMore}
        customStyle={{flex: globalImport.isWeb ? {} : 0}}
        translate={true}
      />
    </View>
  );
};

export default PreviousEarnings;

const styles = StyleSheet.create({
  listItemsStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 11,
    marginHorizontal: 8,
    paddingVertical: 12,
    borderTopWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    backgroundColor: globalConfigurableData.globalThemeColor,
  },
});
